module.exports = __webpack_public_path__ + "13aa0eaf46960c2345bca7fd0410261f.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-114@2x.png
// module id = 497
// module chunks = 0